import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import NoResultsPage from '../../../components/no-results-page/NoResultsPage';
import Table from '../../../components/table/Table';
import TBody from '../../../components/table/TBody/TBody';
import TD from '../../../components/table/TD/TD';
import TH from '../../../components/table/TH/TH';
import THead from '../../../components/table/THead/THead';
import TR from '../../../components/table/TR/TR';
import { getInternalUserProjects } from '../../../core/state/project/asyncActions';
import { RootState } from '../../../core/state/state';
import TableWrapper from '../../components/table-wrapper/TableWrapper';
import Image from '../../../components/image/Image';
import { BASE_URL } from '../../../core/constants/api';

import './InternalUserProjects.scss';

const InternalUserProjects: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const projects = useSelector((state: RootState) => state.projects.internalUserProjects);
  const { userId } = useParams<{ userId: string }>();

  React.useEffect(() => {
    dispatch(getInternalUserProjects(Number(userId)));
  }, [dispatch, userId]);

  return (
    <TableWrapper>
      <div className="table__header">
        <span>{t('internalUsers.projects.title')}</span>
      </div>
      <div className="internal-user-projects__table">
        <Table>
          <THead>
            <TR>
              <TH>{t('common.projectName')}</TH>
              <TH>{t('common.projectNumber')}</TH>
              <TH>{t('common.constructionArea')}</TH>
              <TH>{t('common.userRole')}</TH>
            </TR>
          </THead>
          <TBody>
            {projects?.map((project) => (
              <TR key={project.id}>
                <TD className="d-flex align-items-center">
                  <Image className="project-listing__project-img" src={`${BASE_URL}/${project.photo}`} alt="" />
                  <div className="font-weight-bold">{project.name}</div>
                </TD>
                <TD className="text-left">{project.code}</TD>
                <TD className="text-left">{project.constructionSite}</TD>
                <TD className="text-left">{t(`common.${project.roleName.toLocaleLowerCase()}`)}</TD>
              </TR>
            ))}
          </TBody>
        </Table>
        {!projects ||
          (projects.length === 0 && (
            <NoResultsPage title={t('common.noProjects')} description={t('internalUsers.noProjects.description')} icon="projects" />
          ))}
      </div>
    </TableWrapper>
  );
};

export default InternalUserProjects;
